import { Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { authActions } from "../../store/authSlice";
import { requestLogin } from "../../actions/authentication";
import { useNavigate } from "react-router-dom";
import { AppRoutes } from "../../routes";

import Form from "react-bootstrap/Form";
import { userActions } from "../../store/userSlice";

const LoginForm = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const role = useSelector((state) => state.person.role);
  const email = useSelector((state) => state.auth.email);
  const password = useSelector((state) => state.auth.password);
  dispatch(userActions.setRedirectTo(null));

  const loginHandler = () => {
    dispatch(requestLogin(email, password));
  };

  const onChangeEmail = (event) => {
    dispatch(authActions.setEmail(event.target.value));
    console.log(event.target.value);
  };

  const onChangePassword = (event) => {
    dispatch(authActions.setPassword(event.target.value));
    console.log(event.target.value);
  };

  if (isAuthenticated && role != undefined && role != null) {
    if (role == "Lessee") {
      navigate(AppRoutes.LESSEE_HOME);
    } else if (role == "Owner") {
      navigate(AppRoutes.OWNER_HOME);
    } else if (role == "Admin") {
      <h1>Redirect to Oficina</h1>;
    } else {
      <h1>Redirect Error</h1>;
    }
  } else {
    return (
      <div>
        <Form>
          <Form.Group
            className="mb-3"
            controlId="exampleForm.ControlInputEmail"
          >
            <Form.Label>Email</Form.Label>
            <Form.Control
              type="email"
              placeholder="ana.perez@ejemplo.com"
              onChange={onChangeEmail}
              defaultValue={email}
            />
          </Form.Group>
          <Form.Group className="mb-3" controlId="exampleForm.ControlInputName">
            <Form.Label>Contraseña</Form.Label>
            <Form.Control
              type="password"
              placeholder=""
              onChange={onChangePassword}
              defaultValue={password}
            />
          </Form.Group>
        </Form>

        <Button onClick={loginHandler}>Iniciar sesion</Button>
      </div>
    );
  }
};
export default LoginForm;
